import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {useLoadLookupCollaborator} from 'features/collaborator/hooks';
import {useLoadLookupProfiles} from 'features/profile/hooks';
import useLoadLookupSectors from 'features/sectors/hooks/useLoadLookupSectors';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import useLoadLookupProfSpac from '../../profSpac/hooks/useLoadLookupProfSpac';
import {
  useAddProfCollaborator,
  useDeleteProfCollaborator,
  useLoadProfCollaborator,
} from '../hooks/index';
import {profCollaboratorSchema} from '../model/ProfileCollaborator';
import IntegrityProfCollaborator from './IntegrityProfCollaborator';
import {useUtilInformation} from 'components/hooks';

const ProfCollaboratorGrid = () => {
  const loadProfCollaborator = useLoadProfCollaborator();
  const addProfCollaborator = useAddProfCollaborator();
  const deleteProfCollaborator = useDeleteProfCollaborator();
  const loadLookupCollaborator = useLoadLookupCollaborator();
  const loadLookupProfSpac = useLoadLookupProfSpac();
  const {token, cwid, role} = useUtilInformation();
  const loadLookupSectors = useLoadLookupSectors({token, cwid, role});
  const loadLookupProfiles = useLoadLookupProfiles();

  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      schema={profCollaboratorSchema()}
      dataSource={loadProfCollaborator}
      promiseAdd={addProfCollaborator}
      promiseDelete={deleteProfCollaborator}
      id={['employee_Nr', 'iD_ProfileSpac']}
      remoteLookup={[
        {
          column: 'employee_Nr',
          keyValue: 'employee_Nr',
          displayValue: 'name',
          dataSource: loadLookupCollaborator,
        },
        {
          column: 'iD_ProfileSpac',
          keyValue: 'iD_ProfileSpac',
          displayValue: 'profileDesc',
          dataSource: loadLookupProfSpac,
        },
        {
          column: 'iD_Sector',
          keyValue: 'iD_Sector',
          displayValue: 'name',
          dataSource: loadLookupSectors,
        },
        {
          column: 'iD_Profile',
          keyValue: 'iD_Profile',
          displayValue: 'name',
          dataSource: loadLookupProfiles,
        },
      ]}
      columnOptions={columnOptions}
      integrityGrid={IntegrityProfCollaborator}
      integrityId={['Employee_Nr', 'ID_ProfileSpac']}
      integrityName={'CollaboratorProfile'}>
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column caption={i18n2._('Colaborador')} dataField="name_Employee" />
      <Column
        caption={i18n2._('CWID')}
        dataField="cwid"
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('#Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('SPAC')} dataField="spac" />
      <Column caption={i18n2._('Nombre del SPAC')} dataField="name_Spac" />
      <Column caption={i18n2._('Profile Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

const columnOptions = [
  {
    column: 'employee_Nr',
    myLabel: i18n2._('Nombre del colaborador'),
    keyForFilter: 'iD_Sector',
    keyForFilterSecond: 'iD_Profile',
    required: true,
    selectType: 'multipleLimitedByColumn',
    allowEdit: false,
  },
  {
    selectType: 'multiple',
    lookupColumn: 'spac',
    column: 'iD_ProfileSpac',
    required: true,
    myLabel: i18n2._('Profile Spac'),
    allowEdit: false,
  },
  {
    column: 'throwInstances',
    sizeMobile: 12,
    sizeDesktop: 12,
    hiddenEdit: true,
    myLabel: i18n2._('Lanzar instancias'),
  },
  {
    column: 'spac',
    hiddenAdd: true,
    hiddenEdit: true,
  },
  {
    column: 'name_ProfSpac',
    hiddenAdd: true,
    hiddenEdit: true,
  },
  {
    column: 'name_Employee',
    hiddenAdd: true,
    hiddenEdit: true,
  },
  {
    column: 'name_Spac',
    hiddenAdd: true,
    hiddenEdit: true,
  },
  {
    column: 'cwid',
    hiddenAdd: true,
    hiddenEdit: true,
  },
  {
    column: 'iD_Profile',
    selectType: 'limitedByColumn',
    myLabel: i18n2._('Perfil'),
    keyForFilter: 'iD_Sector',
    showAll: true,
  },
  {
    column: 'iD_Sector',
    required: true,
    myLabel: i18n2._('Sector'),
  },
];

export default ProfCollaboratorGrid;
